/**
 * @param {*} snapshot
 * @param {(item: {id: string, value: object, proprity: *}) => void} onNewItem
 * @param {*} onNewItemCallStack - mutable dictionary to ensure onNewItemCallStack is called once per item
 * @returns {Array<{id: string, value: object, proprity: *}>}
 */
export default function getSnapshotItems(
  snapshot,
  onNewItem,
  onNewItemCallStack
) {
  let items = [];

  snapshot.forEach((childSnap) => {
    const item = {
      id: childSnap.key,
      value: childSnap.val(),
      priority: childSnap.getPriority(),
    };

    items.unshift(item);

    /**
     * onNewItem callback
     * mutates onNewItemCallStack
     */
    if (onNewItem && !onNewItemCallStack[item.id]) {
      onNewItem(item);
      onNewItemCallStack[item.id] = true;
    }
  });

  return items;
}
